import { forwardRef } from 'react';

export interface SummaryIssue {
  key: string;
  message: string;
}

/**
 * The validation summary at the top of a form: announced as an alert, focused when it appears, and each item moves focus to the
 * field it is about. Messages never echo what was typed.
 */
export const ErrorSummary = forwardRef<HTMLDivElement, { issues: SummaryIssue[]; onSelect: (key: string) => void }>(function ErrorSummary(
  { issues, onSelect },
  ref,
) {
  if (issues.length === 0) return null;
  return (
    <div ref={ref} className="jr-summary" role="alert" tabIndex={-1} data-testid="error-summary">
      <p className="jr-summary__title">
        <span aria-hidden="true">{'⚠'} </span>
        {issues.length === 1 ? 'Fix 1 thing to continue' : `Fix ${issues.length} things to continue`}
      </p>
      <ul>
        {issues.map((issue) => (
          <li key={issue.key}>
            <button type="button" className="link" onClick={() => onSelect(issue.key)}>{issue.message}</button>
          </li>
        ))}
      </ul>
    </div>
  );
});
